import type { Styles } from 'common/types';

export const styles: Styles = {
  container: {
    p: 2,
    borderRadius: 2,
    width: 320,
    height: 370,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid',
    borderColor: 'divider',
    backgroundColor: '#ffffff',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      boxShadow: '0px 12px 24px rgba(0, 0, 0, 0.08)',
      borderColor: 'primary.light',
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    mb: 0.5,
  },
  dragHandle: {
    cursor: 'grab',
    color: 'text.disabled',
    display: 'flex',
    alignItems: 'center',
  },
  stack: {
    flex: 1,
    overflow: 'hidden',
  },
  textField: {
    '& .MuiInputBase-inputMultiline': {
      height: '80px !important',
      overflow: 'auto !important',
      resize: 'none !important',
    },
  },
};
